import { Parser } from "html-to-react"
interface IProps {
  content: string
}

const parser = new Parser()

/**
 * This component transforms HTML-content into react-compatible content
 */
const HtmlContent: React.FC<IProps> = ({ content }: IProps) => {
  return <>{parser.parse(content)}</>
}

export default HtmlContent
